import i18n from '@/utils/i18n';
import React from 'react';
import { AddInboundItemSearchContent } from './add-inbound-item-search-content';
import { ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import { OrderInboundsStackParams } from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import {
  selectHasPendingItems,
  selectZeroQuantitySearchInputUUIDs,
  useOrderInboundDetailStore,
} from './store/order-inbound-detail-store';
import { StackScreenProps } from '@react-navigation/stack';
import { StyleSheet, View } from 'react-native';
import { useShallow } from 'zustand/shallow';

type Props = StackScreenProps<
  OrderInboundsStackParams,
  ORDER_INBOUNDS_ROUTES.AddSearch
>;

export const AddItemSearchScreen: React.FC<Props> = ({ route }) => {
  const clearPendingQuantityMap = useOrderInboundDetailStore(
    (state) => state.actions.clearPendingQuantityMap,
  );
  const zeroQuantitySearchInputUUIDs = useOrderInboundDetailStore(
    useShallow(selectZeroQuantitySearchInputUUIDs),
  );
  const hasPendingItems = useOrderInboundDetailStore(
    useShallow(selectHasPendingItems),
  );
  const dispatch = route.params.dispatch;
  const smartOrderUUID = route.params.smartOrderUUID;

  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: () => {
          route.params.onClose(hasPendingItems);
          if (zeroQuantitySearchInputUUIDs.length > 0) {
            dispatch({
              payload: { searchInputUUIDs: zeroQuantitySearchInputUUIDs },
              type: 'REMOVE_ITEMS',
            });
          }
          clearPendingQuantityMap();
        },
        showBackButton: true,
        showShadow: true,
        title: i18n.t('search'),
      }}
    >
      <View style={styles.container}>
        <AddInboundItemSearchContent
          dispatch={dispatch}
          smartOrderUUID={smartOrderUUID}
        />
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 16,
  },
});
